import React from "react";

function Footer() {
  return (
    <div>
      <footer>
        <div className="container">
          <div className="col-lg-8">
            <p>
              Copyright © 2025 Villa Agency Co., Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
